import '../../assets/styles/login.css';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEye,
    faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import { loginUser } from '../../assets/constants/global_apis';
import { useDispatch } from "react-redux";
import { setLoginUser } from '../../common_functions/store';
import { useNavigate } from "react-router-dom";


export default function Login({triggerAlert,setCurrentPage}) {
    // const toast  = useRef(null);
    const [reqData, setReqData] = useState({});
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setReqData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        try {
            localStorage.removeItem('authtoken');
            localStorage.removeItem('role');
            localStorage.removeItem('init_password');
        } catch (e) {
            console.error('User not logged in');
        }
    })

    const handleSubmit = (e) => {
        e.preventDefault();
        if (reqData?.password != undefined && reqData?.password.length < 8) {
            triggerAlert('Error', 'Password must be at least 8 characters');
        } else if (reqData?.username != undefined && reqData?.username.length == 0) {
            triggerAlert('Error', 'Username should not be empty');
        } else {
            loginUser(reqData).then((response) => {
                dispatch(setLoginUser({
                    authToken: response?.token,
                    role: response?.role,
                    userName: response?.username,
                    init_password: response?.init_password == 'true' ? true : false
                }));
                localStorage.setItem('authToken', response?.token);
                localStorage.setItem('role', response?.role);
                localStorage.setItem('username', response?.username);
                localStorage.setItem('user_id', response?.id);
                localStorage.setItem('init_password', response?.init_password);
                triggerAlert('Success', 'Successfully Login!!!');
                if (response?.init_password == 'true') {
                    setCurrentPage("/update-password")
                    navigate("/update-password");
                } else {
                    navigate("/explorer");
                }
            }).catch((error) => {
                triggerAlert('Error', error.message);
            });
        }
    };


    return (
        <>
            <form role="form" className="text-start"
                onSubmit={handleSubmit}
            ><div>
                    <label>UserName</label>
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name='username'
                            placeholder="username"
                            aria-label="UserName"
                            value={reqData?.username}
                            onChange={handleChange}
                        /> </div>
                </div>
                <label>Password</label>
                <div className="mb-3 password-input">
                    <input
                        placeholder={"password"}
                        aria-label={"password"}
                        className="form-control"
                        type={isPasswordVisible ? 'text' : 'password'}
                        name='password'
                        value={reqData?.password}
                        onChange={handleChange}
                    />
                    <div className='password-visible-controller'>
                        {
                            isPasswordVisible ? <FontAwesomeIcon icon={faEye} onClick={() => setIsPasswordVisible(false)} style={{ marginLeft: '8%' }} /> :
                                <FontAwesomeIcon icon={faEyeSlash} onClick={() => setIsPasswordVisible(true)} />
                        }
                    </div>

                </div>

                <a href="/forgot-password" className="link-text">
                    Forgot password?
                </a>
                <div className="form-check form-switch d-none">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="rememberMe"
                    />
                    <label
                        className="form-check-label"
                        htmlFor="rememberMe"
                    >
                        Remember me
                    </label>
                </div>


                <div className="text-center">
                    <button
                        type="submit"
                        className="btn bg-gradient-info w-100 mt-4 mb-0"
                    >
                        Login
                    </button>
                </div>
            </form>
        </>
    );
}
